import React from "react";
import { Lock, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DemoPrivacyNotice = ({ compact = false }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      className={`mx-auto rounded-2xl border border-[#EADDD7] bg-white/85 backdrop-blur-sm shadow-sm ${
        compact ? "max-w-xl px-4 py-3" : "max-w-3xl px-4 sm:px-5 py-3.5"
      }`}
      data-testid="demo-privacy-notice"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-start gap-2.5 min-w-0">
          <Lock className="h-4 w-4 mt-0.5 shrink-0 text-[#9B6A6C]" aria-hidden="true" />
          <p className="text-xs sm:text-sm text-[#5C4B51] leading-relaxed">
            <span className="font-medium text-[#2C2123]">{t("demo.ephemeral.privateTitle")}</span>{" "}
            {t("demo.ephemeral.privateBody")}
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate("/demo")}
          className="shrink-0 inline-flex items-center gap-1 text-xs text-[#9B6A6C] hover:text-[#7d5455]"
          data-testid="demo-start-over"
        >
          <RotateCcw className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">{t("demo.ephemeral.startOver")}</span>
        </button>
      </div>
    </div>
  );
};

export default DemoPrivacyNotice;
